// JQ4-14 — US-ORG-006: Daily Summary Dashboard

import type { DailySummaryResponse } from '@jq4race/shared';
import { dailySummarySchema } from '@jq4race/shared';

import { request } from './client.js';

export async function getDailySummary(locationId: string): Promise<DailySummaryResponse> {
  const payload = await request<unknown>(
    `/admin/locations/${encodeURIComponent(locationId)}/daily-summary`,
    { method: 'GET' },
  );
  // Runtime-validate the response so a null/empty/malformed 200 body throws an ApiError
  // rather than silently returning an unsound cast that would crash the dashboard.
  return dailySummarySchema.parse(payload);
}
